export const validateField = (name, value, password = '', countryCode = '+1') => {
    let error = '';

    switch (name) {
        case 'firstName':
        case 'lastName':
            if (!value.trim()) error = 'This field is required';
            else if (value.length < 2) error = 'Must be at least 2 characters';
            else if (!/^[a-zA-Z]+$/.test(value)) error = 'Only letters allowed';
            break;

        case 'email':
            if (!value.trim()) error = 'Email is required';
            else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = 'Invalid email format';
            break;

        case 'password':
            if (value.length < 8) error = 'Must be at least 8 characters';
            else if (!/[A-Z]/.test(value)) error = 'At least one uppercase letter (A–Z)';
            else if (!/[a-z]/.test(value)) error = 'At least one lowercase letter (a–z)';
            else if (!/[0-9]/.test(value)) error = 'At least one number (0–9)';
            break;


        case 'confirmPassword':
            if (!value.trim()) error = 'Confirm password is required';
            else if (value !== password) error = 'Passwords do not match';
            break;

        case 'msisdn':
            if (!value.trim()) {
                error = 'Phone number is required';
            } else {
                // Strip all non-digit characters
                const fullDigits = value.replace(/\D/g, '');
                const countryDigits = countryCode.replace(/\D/g, '');

                // Remove the country code part from beginning if present
                let phoneDigits = fullDigits.startsWith(countryDigits)
                    ? fullDigits.slice(countryDigits.length)
                    : fullDigits;

                let minLength, maxLength;
                if (
                    ['+1', '+1-684', '+1-264', '+1-268', '+1-242', '+1-441', '+1-473', '+1-767', '+1-809', '+1-869', '+1-758', '+1-784', '+1-868', '+1-876'].includes(countryCode)
                ) {
                    minLength = 10;
                    maxLength = 17;
                } else if (['+44', '+91', '+92', '+880', '+86'].includes(countryCode)) {
                    minLength = 10;
                    maxLength = 17;
                } else {
                    minLength = 8;
                    maxLength = 17;
                }

                if (phoneDigits.length < minLength || phoneDigits.length > maxLength) {
                    error = `Phone number must be between ${minLength} and ${maxLength} digits`;
                }
            }
            break;

        default:
            if (!value.trim()) error = 'This field is required';
            break;
    }

    return error;
};


export const validateForm = (formData, fieldNames, countryCode = '+1') => {
    const errors = {};
    let isValid = true;

    fieldNames.forEach(name => {
        const error = validateField(name, formData[name] || '', formData.password, countryCode);
        errors[name] = error;
        if (error) isValid = false;
    });

    return { errors, isValid };
};
